import { fetchWithAuth } from "./FetchWithAuth";
import { url } from "./url";

const BASE = `${String(url).replace(/\/+$/, "")}/api/bounties`;

async function request(path, options = {}) {
  const endpoint = `${BASE}${path}`;
  const response = await fetchWithAuth(endpoint, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.error || `Request failed ${response.status}`);
  }
  return response.json();
}

/**
 * Normalize API bounty to board/card shape (id, name, description, reward_type, reward_value, expires_at, status, claimedBy, completedBy).
 */
function normalizeBounty(b) {
  if (!b) return b;
  return {
    ...b,
    expires_at: b.expires_at || null,
    claimedBy: b.claimedBy
      ? {
          name: b.claimedBy.name,
          avatar: b.claimedBy.avatar || null,
          isCurrentUser: b.claimedBy.isCurrentUser === true,
        }
      : undefined,
    completedBy: b.completedBy
      ? { name: b.completedBy.name, avatar: b.completedBy.avatar || null }
      : undefined,
  };
}

export const bountyApi = {
  list: async () => {
    const res = await request("");
    const data = Array.isArray(res.data) ? res.data : [];
    return { data: data.map(normalizeBounty), total: res.total ?? data.length };
  },
  getById: async (id) => {
    const b = await request(`/${id}`);
    return normalizeBounty(b);
  },
  create: (payload) =>
    request("", {
      method: "POST",
      body: JSON.stringify({
        name: payload.name,
        description: payload.description || "",
        reward_type: payload.reward_type || "Cash",
        reward_value: payload.reward_value,
        conversions_required: payload.conversions_required ?? 1,
        scope_type: payload.scope_type || "overall",
        scope_id: payload.scope_id ?? null,
        expires_at: payload.expires_at || null,
      }),
    }),
  active: () => request("/active"),
  update: (id, payload) =>
    request(`/${id}`, {
      method: "PATCH",
      body: JSON.stringify({
        name: payload.name,
        description: payload.description,
      }),
    }),
  claim: (id) => request(`/${id}/claim`, { method: "POST" }),
  complete: (id) => request(`/${id}/complete`, { method: "POST" }),
  activity: (id) => request(`/${id}/activity`),
};
